function setScrollbarProperty() {
    const hasScrollbar = document.documentElement.scrollHeight > document.documentElement.clientHeight;
    if (hasScrollbar) {
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
    } else {
        document.documentElement.style.setProperty('--scrollbar-width', `0px`);
    }
}

export function detectScrollbarWidth() {
    let resizeTimeout: number | null = null;
    window.addEventListener('resize', () => {
        if (resizeTimeout) clearTimeout(resizeTimeout);

        resizeTimeout = window.setTimeout(() => {
            setScrollbarProperty();
            resizeTimeout = null;
        }, 100);
    });
    window.addEventListener('load', setScrollbarProperty);
}
